import { buttonClasses, ThemeOptions } from '@mui/material';
import { radius } from 'themes/radius';
import { color } from 'themes/color';
import { CobrandIdentifier } from 'features/cobrand/types';

// Update the Typography's options
declare module '@mui/material/Button' {
  interface ButtonPropsSizeOverrides {
    xlarge: true;
  }
  interface ButtonPropsVariantOverrides {
    primary: true;
    tertiary: true;
  }
}

// TODO: Style the accept methods as well and returns theme in the parameter.
// The generator files should be updated to use this instead of using the cobrand colors directly.
// Ticket: https://wellframe.atlassian.net/browse/WFMOB-13755

export const generateButtonThemeOptions = (
  cobrand: CobrandIdentifier,
): ThemeOptions['components'] => {
  const colors = color[cobrand];

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      variants: [
        // Explicitly handle size to support custom variants due to a known bug in MUI
        // Replicating what exists in mui by default
        // Issue link: https://github.com/mui/material-ui/issues/32427
        {
          props: { size: 'xlarge' },
          style: { height: '55px' },
        },
        {
          props: { size: 'small' },
          style: { padding: '4px 10px', fontSize: '0.8125rem' },
        },
        {
          props: { size: 'large' },
          style: { padding: '8px 22px' },
        },
        {
          props: { variant: 'tertiary' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.brandBackgroundSecondary.main,
            color: theme.palette.brandShade1.main,
            '&:hover': {
              backgroundColor: theme.palette.brandBackgroundPrimary,
            },
          }),
        },
        {
          props: { variant: 'primary' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: theme.palette.secondary.dark,
            },
            '&:disabled': {
              color: theme.palette.common.white,
              opacity: '0.5',
            },
          }),
        },
      ],
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: radius.pill,
          [`&.${buttonClasses.contained}.${buttonClasses.disabled}`]: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
            opacity: '0.5',
          },
        }),
      },
    },
    MuiIconButton: {
      defaultProps: {
        color: colors.grey[800],
        sx: {
          '&:disabled': {
            color: colors.grey[500],
          },
        },
      },
      styleOverrides: {
        root: {
          borderRadius: radius.pill,
        },
      },
    },
  };
};
